import { render } from "./logoutTips.vue?vue&type=template&id=1a4680c1"
const script = {}

import "./logoutTips.vue?vue&type=style&index=0&id=1a4680c1&lang=less"

import exportComponent from "D:\\workday\\code\\h5-moxigecash\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__